module.exports = __webpack_public_path__ + "media/images/undraw/profile-82f4a8c153fbfc96d8a3904cdc514275.png";